import { useState } from 'react'

import { useAppSelector } from 'app/hooks'

import {
  ILineGraphsViewProps,
  QRAGraphType
} from 'features/RiskManagement/Components/Graphs'
import { GraphComponentById } from 'features/RiskManagement/Components/Graphs/graphComponentById'
import {
  getRiskForecastRowClassName,
  RiskForecastGraphs
} from 'features/RiskManagement/Components/Graphs/Implementations/RiskForecastGraphs'
import {
  selectRiskUnit,
  selectSavedFilter
} from 'features/RiskManagement/Components/LocalFilter/localFilterSelectors'

import { GraphGrid, type GraphGridItem } from './GraphGrid'

const standardLayout: GraphGridItem<QRAGraphType>[] = [
  {
    graphType: QRAGraphType.THREATS,
    rowClassName: 'comparisonBreakdown'
  },
  {
    graphType: QRAGraphType.CONSEQUENCES,
    rowClassName: 'comparisonBreakdown'
  },
  {
    graphType: QRAGraphType.LINEAR_REFERENCE,
    rowClassName: 'linearReference'
  },
  {
    graphType: QRAGraphType.RISK_FORECAST,
    rowClassName: 'forecast'
  },
  {
    graphType: QRAGraphType.RISK_BY_SIGNIFICANCE_LEVEL,
    rowClassName: 'riskSummary'
  },
  {
    graphType: QRAGraphType.RISK_BY_SYSTEM,
    rowClassName: 'riskSummary'
  }
]

const getLineViewGraphGridItems = (
  riskForecastGraphType: RiskForecastGraphs
): GraphGridItem<QRAGraphType>[] =>
  standardLayout.map((item) => {
    if (item.graphType !== QRAGraphType.RISK_FORECAST) {
      return item
    }

    return {
      ...item,
      rowClassName: getRiskForecastRowClassName(riskForecastGraphType)
    }
  })

const GraphsView = ({
  qraBasePath,
  showLoading,
  charts = {},
  riskByPipelineLengthGraphData,
  riskBySystemGraphData,
  graphLoadingByType,
  csvExportParams
}: ILineGraphsViewProps) => {
  const localFilter = useAppSelector(selectSavedFilter)
  const riskUnit = useAppSelector(selectRiskUnit)
  const [riskForecastGraphType, setRiskForecastGraphType] =
    useState<RiskForecastGraphs>(RiskForecastGraphs.ByThreat)

  const layout = getLineViewGraphGridItems(riskForecastGraphType)

  return (
    <GraphGrid items={layout} testId='line-graphs-grid'>
      {({ graphType }) => (
        <GraphComponentById
          graphType={graphType}
          showLoading={showLoading}
          graphLoading={graphLoadingByType?.[graphType]}
          charts={charts}
          riskByPipelineLengthGraphData={riskByPipelineLengthGraphData}
          riskBySystemGraphData={riskBySystemGraphData}
          riskUnit={riskUnit}
          localFilter={localFilter}
          qraBasePath={qraBasePath}
          csvExportParams={csvExportParams}
          onRiskForecastGraphTypeChange={setRiskForecastGraphType}
        />
      )}
    </GraphGrid>
  )
}

export default GraphsView
